import React from "react";
import { useTranslation } from "next-i18next";
import { IUnderlyingsInTextData } from "src/api/server/news.types";
import { useNumberFormatter } from "src/hooks/formatters/use-number-formatter";
import { useLinkBuilder } from "src/hooks/use-link-builder";
import { ParagraphProcessor } from "./paragraph-processor";

interface IParagraphWithMentionsProps {
    underlyingsInTextData: IUnderlyingsInTextData[];
    paragraph: string;
}

export const ParagraphWithMentions = ({ underlyingsInTextData, paragraph }: IParagraphWithMentionsProps) => {
    const { formatPerformance } = useNumberFormatter();
    const { t } = useTranslation("news");
    const { buildWikifolioLink } = useLinkBuilder();

    return (
        <ParagraphProcessor
            paragraph={paragraph}
            underlyingsInTextData={underlyingsInTextData}
            formatPerformance={formatPerformance}
            t={t}
            buildWikifolioLink={buildWikifolioLink}
        />
    );
};
